<script>
export default {
	name: "ValidatedInput",
	props: {
		modelValue: { type: String, required: true },
		label: { type: String },
		placeholder: { type: String },
		isValid: { type: Boolean, required: true },
		errorMessage: { type: String },
	},
	emits: ["update:modelValue"],
};
</script>

<template lang="pug">
.form-group
	label(v-if="label") {{ label }}
	input.ov-input.form-control(
		:value="modelValue",
		:placeholder="placeholder",
		:class="{ 'ov-input--invalid': !isValid }",
		@input="$emit('update:modelValue', $event.target.value)",
	)
	p.ov-field__error(v-if="!isValid && errorMessage") {{ errorMessage }}
</template>

<style lang="scss">
.ov-input--invalid {
	border-color: var(--ds-color-danger) !important;
}
.ov-field__error {
	margin: var(--ds-space-1) 0 0;
	font-size: var(--ds-font-size-xs);
	color: var(--ds-color-danger);
}
</style>
